import { FormattedMessage } from 'react-intl';

import {
  DashboardOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  ApartmentOutlined,
  UserAddOutlined,
  RocketOutlined
} from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  ApartmentOutlined,
  UserAddOutlined,
  RocketOutlined
};

const superAdminMenu = {
  items: [
    {
      id: 'super-admin-group',
      title: "Super Admin" ,
      type: 'group',
      children: [
        {
          id: 'super-admin',
          title: "Overview" ,
          type: 'item',
          url: '/super-admin',
          icon: icons.DashboardOutlined
        },
        {
          id: 'super-admin-cities',
          title: "City Management" ,
          type: 'item',
          url: '/super-admin/cities',
          icon: icons.EnvironmentOutlined
        },
        {
          id: 'super-admin-consultants',
          title: "Consultant Management" ,
          type: 'item',
          url: '/super-admin/consultants',
          icon: icons.TeamOutlined
        },
        {
          id: 'super-admin-register',
          title: "Register Super Admin",
          type: 'item',
          url: '/super-admin/register',
          icon: icons.UserAddOutlined
        },
        {
          id: 'super-admin-organizations',
          title: "Organizations" ,
          type: 'item',
          url: '/super-admin/organizations',
          icon: icons.ApartmentOutlined,
          disabled: true
        },
        {
          id: 'super-admin-tools',
          title: "Tools",
          type: 'collapse',
          icon: icons.RocketOutlined,
          children: [
            {
              id: 'super-admin-asset-detection',
              title: "Asset Detection (GS)",
              type: 'item',
              url: '/asset-detection-gs'
            },
            {
              id: 'super-admin-asset-detection-2',
              title: "Asset Detection" ,
              type: 'item',
              url: '/asset-detection'
            },
            {
              id: 'super-admin-pavement-inspection',
              title: "Pavement Inspection" ,
              type: 'item',
              url: '/pavement-inspection'
            },
            {
              id: 'super-admin-inventory-creator',
              title: "Inventory Creator",
              type: 'item',
              url: '/inventory-creator'
            },
            {
              id: 'super-admin-inventory-creator-utility',
              title: 'Inventory Creator (Utility)',
              type: 'item',
              url: '/inventory-creator-utility'
            },
            {
              id: 'super-admin-deterioration-modelling',
              title:"Deterioration Modelling" ,
              type: 'item',
              url: '/deterioration-modelling'
            },
            {
              id: 'super-admin-esri-integration',
              title: "Esri Integration" ,
              type: 'item',
              url: '/esri-integration'
            },
            {
              id: 'super-admin-building-modelling',
              title: "Building Modelling" ,
              type: 'item',
              url: '/building-modelling'
            },
            {
              id: 'super-admin-building-viewer',
              title: 'Building Viewer',
              type: 'item',
              url: '/building-viewer'
            },
            {
              id: 'super-admin-facility-viewer',
              title: 'Facility Viewer',
              type: 'item',
              url: '/facility-viewer'
            }
          ]
        }
      ]
    }
  ]
};

export default superAdminMenu;
